const navigatorIsAvailable = typeof navigator !== 'undefined';

export default navigatorIsAvailable;
